import { Box, Divider } from '@mui/material';
import React from 'react';
import { EasTableInfoPannelItem } from './EasTableInfoPannelItem';

export type TEasTableInfoPannelStructure = {
	label: string;
	key: string;
	type: string;
	statuses?: [string, string][];
};

export type TEasTableInfoPannelData = {
	[key: string]: string;
};

export const EasTableInfoPannel = ({
	structure,
	data,
}: {
	structure: TEasTableInfoPannelStructure[];
	data: TEasTableInfoPannelData;
}) => {
	return (
		<Box sx={{ display: 'flex', flexDirection: 'row', gap: 1, alignItems: 'center' }}>
			{structure.map((item: TEasTableInfoPannelStructure, index: number) => (
				<React.Fragment key={item.key}>
					<EasTableInfoPannelItem
						key={item.key}
						label={item.label}
						value={data?.[item.key] || '-'}
						type={item.type}
						statuses={item.statuses}
					/>
					{index !== structure.length - 1 && (
						<Divider
							orientation="vertical"
							flexItem
							// color="primary"
							sx={{ backgroundColor: 'primary.main' }}
						/>
					)}
				</React.Fragment>
			))}
		</Box>
	);
};
